import { Column } from './types'
import { headerProps } from './useHeaderColumnProps'


const columnProps = {
  ...headerProps,
  [Column.Title]: { alignLeft: true },
  [Column.BalanceAtTheBeginning]: { alignRight: true },
  [Column.BalanceAtTheEnd]: { alignRight: true },
  [Column.Revenue]: { alignRight: true },
  [Column.Collected]: { alignRight: true },
  [Column.EncashmentsCount]: { alignRight: true },
}

export function useColumnProps() {
  return columnProps
}
